export default __webpack_public_path__ + "static/media/6.84f49261.jpg";